// extracted by mini-css-extract-plugin
module.exports = {"contact":"styles-module--contact--3O6K8","subject":"styles-module--subject--2yANj"};